import { useI18n } from "@/i18n";

import { getFooterLinks, SITE_LINKS } from "./site-links";

/**
 * Site footer shown on every auth screen.
 *
 * Renders localized legal-link labels and destinations, plus the copyright.
 */
export function Footer() {
  const { locale, messages } = useI18n();
  const { footer } = messages.shared;
  const links = getFooterLinks(locale);

  return (
    <footer className="mt-auto w-full bg-background-emphasis py-2 sm:py-3.5">
      <div className="mx-auto flex w-full max-w-[808px] flex-col gap-1 px-1 sm:gap-1.5 sm:px-1.5">
        {/* Localized legal links. */}
        <nav
          className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-0.75 sm:gap-1.5"
          aria-label={footer.ariaLabel}
        >
          <FooterLink
            href={links.customerService.href}
            label={footer.customerService}
          />
          <FooterLink
            href={links.legalNotice.href}
            label={footer.legalNotice}
          />
          <FooterLink
            href={links.dataProtection.href}
            label={footer.dataProtection}
          />
        </nav>

        {/* Static copyright notice. */}
        <div className="flex items-center justify-center border-t border-line-stroke-base pt-0.5 sm:mx-3.5">
          <p className="m-0 text-xs text-text-primary">
            {SITE_LINKS.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ href, label }: { href: string; label: string }) {
  return (
    <a
      href={href}
      className="text-sm font-medium text-action-primary underline transition-colors hover:text-text-secondary"
    >
      {label}
    </a>
  );
}
